import { ForkEffect, put, PutEffect, takeEvery } from 'redux-saga/effects';
import { Socket } from 'socket.io-client';

import { send } from '../send-request';
import {
  withdrawalCancelOrder,
  withdrawalCreate,
  withdrawalCreateResponse,
  withdrawalLinkOrder,
  withdrawalLoad,
  withdrawalMutationResponse,
  withdrawalOrderSearch,
  withdrawalReceivedCount,
  withdrawalSetStatus,
  withdrawalsLoad,
  withdrawalsLoadByOrder,
} from './reducer';

export function* refreshReceivedCount(): Generator<PutEffect, void, void> {
  yield put(withdrawalReceivedCount());
}

export function* watch(
  socket: Socket,
): Generator<ForkEffect<never>, void, string> {
  yield takeEvery(withdrawalsLoad.type, send, socket);
  yield takeEvery(withdrawalLoad.type, send, socket);
  yield takeEvery(withdrawalOrderSearch.type, send, socket);
  yield takeEvery(withdrawalLinkOrder.type, send, socket);
  yield takeEvery(withdrawalSetStatus.type, send, socket);
  yield takeEvery(withdrawalCancelOrder.type, send, socket);
  yield takeEvery(withdrawalCreate.type, send, socket);
  yield takeEvery(withdrawalReceivedCount.type, send, socket);
  yield takeEvery(withdrawalsLoadByOrder.type, send, socket);
  yield takeEvery(
    [withdrawalMutationResponse.type, withdrawalCreateResponse.type],
    refreshReceivedCount,
  );
}
